import {
  BASKET_PAGE,
  CUSTOM_PICK_PAGE,
  GAME_ANALYSIS_PAGE,
  HAPPY_PICK_PAGE,
  PROTO_GAME_PAGE, TOTO_PAGE
} from "./page_constants";
import {RiBookmarkLine, RiEmotionHappyLine, RiPieChartLine, RiPuzzleLine} from "react-icons/ri";

// <-- 헤더 --> //
export const HEADER_MENU = [
  {name: "프로토", link: PROTO_GAME_PAGE, icon: RiBookmarkLine},
  {name: "바구니", link: BASKET_PAGE, icon: RiBookmarkLine},
  {name: "토토", link: TOTO_PAGE, icon: RiBookmarkLine},
  // {name: "경기 분석", link: GAME_ANALYSIS_PAGE, icon: RiPieChartLine},
  // {name: "행복픽", link: HAPPY_PICK_PAGE, icon: RiEmotionHappyLine},
  // {name: "커스텀픽", link: CUSTOM_PICK_PAGE, icon: RiPuzzleLine},
]

// <-- 메인페이지 경기 필터 버튼 --> //
export const PROTO_CATEGORY_FILTER_BUTTONS_DATA = [
  {name: "전체", value: "all"},
  {name: "축구", value: "SC"},
  {name: "농구", value: "BK"},
  {name: "야구", value: "BS"},
  {name: "배구", value: "VL"},
]

// <-- 바구니 조건 필터 버튼 --> //
export const BASKET_FILTER_BUTTON_DATA = [
  {
    key: 'folder',
    title: '폴더',
    options: [
      { label: '3', value: 3 },
      { label: '4', value: 4 },
      { label: '5', value: 5 },
      { label: '6', value: 6 },
      { label: '7', value: 7 },
      { label: '8', value: 8 },
      { label: '9', value: 9 },
      { label: '10', value: 10 },
    ],
    isMultiple: false,  // 단일 선택
  },
  {
    key: 'types',
    title: '유형',
    options: [
      { label: '일반', value: '일반' },
      { label: '핸디', value: '핸디' },
      { label: 'U/O', value: 'U/O' },
      { label: 'SUM', value: '홀짝' },
    ],
    isMultiple: true,  // 복수 선택
  },
  {
    key: 'sports',
    title: '종목',
    options: [
      { label: '축구', value: '축구' },
      { label: '농구', value: '농구' },
      { label: '배구', value: '배구' },
      { label: '야구', value: '야구' },
    ],
    isMultiple: true,
  },
  {
    key: 'odds',
    title: '배당',
    options: [
      { label: '50~60', value: '50~60' },
      { label: '60~70', value: '60~70' },
      { label: '70~80', value: '70~80' },
      { label: '80~90', value: '80~90' },
      { label: '90~100', value: '90~100' },
    ],
    isMultiple: false,
    hasDivider: true, // 구분선 유무
  },
]

// <-- 토토 경기 필터 버튼 --> //
export const TOTO_CATEGORY_FILTER_BUTTONS_DATA = [
  {name: "축구토토", value: "sc"},
  {name: "농구토토", value: "bk"},
  {name: "야구토토", value: "bs"},
  {name: "배구토토", value: "vl"},
  {name: "골프토토", value: "gf"},
  {name: "언더오버", value: "uo"},
]

export const TOTO_PRICE_LIST = [
  { name: "자동 금액 선택", value: 0, combination: {} },
  { name: "1,000원", value: 1000, combination: {2: 0, 3: 0} },
  { name: "4,000원", value: 4000, combination: {2: 2, 3: 0} },
  { name: "6,000원", value: 6000, combination: {2: 1, 3: 1} },
  { name: "8,000원", value: 8000, combination: {2: 3, 3: 0} },
  { name: "9,000원", value: 9000, combination: {2: 0, 3: 2} },
  { name: "12,000원", value: 12000, combination: {2: 2, 3: 1} },
  { name: "24,000원", value: 24000, combination: {2: 3, 3: 1} },
  { name: "32,000원", value: 32000, combination: {2: 5, 3: 0} },
  { name: "48,000원", value: 48000, combination: {2: 4, 3: 1} },
  { name: "54,000원", value: 54000, combination: {2: 1, 3: 3} },
  { name: "64,000원", value: 64000, combination: {2: 6, 3: 0} },
  { name: "72,000원", value: 72000, combination: {2: 3, 3: 2} },
  { name: "81,000원", value: 81000, combination: {2: 0, 3: 4} },
  { name: "96,000원", value: 96000, combination: {2: 5, 3: 1} },
]

// <-- 메인페이지 필터조건 테이블 --> 전자게시판에서 사용 XXX //
export const FILTER_TABLE_DATA = [
  {
    title: '종목',
    options: [
      {id: 'category_all', value: '전체'},
      {id: 'category_soccer', value: '축구'},
      {id: 'category_basketball', value: '농구'},
      {id: 'category_baseball', value: '야구'},
      {id: 'category_volleyball', value: '배구'}
    ]
  }
];

// <-- 티켓 금액 버튼 --> //
export const MONEY_BUTTON_DATA = [
  {name: "+ 1백", value: 100,},
  {name: "+ 1천", value: 1000,},
  {name: "+ 5천", value: 5000,},
  {name: "+ 1만", value: 10000,},
  {name: "+ 2만", value: 20000,},
  {name: "+ 3만", value: 30000,},
  {name: "+ 5만", value: 50000,},
  {name: "+ 10만", value: 100000,},
]